/** Legacy `ExpressRegistrationForm.generateTemporaryPassword` — used when `promptPassword` is false. */
function pickRandom(input: string): string {
  return input[Math.floor(Math.random() * input.length)]!;
}

export function generateExpressTemporaryPassword(): string {
  const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const lower = "abcdefghijkmnopqrstuvwxyz";
  const digits = "23456789";
  const symbols = "!@#$%^&*";
  const pool = `${upper}${lower}${digits}${symbols}`;

  const chars = [pickRandom(upper), pickRandom(lower), pickRandom(digits), pickRandom(symbols)];
  for (let i = 0; i < 12; i += 1) {
    chars.push(pickRandom(pool));
  }

  for (let i = chars.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [chars[i], chars[j]] = [chars[j]!, chars[i]!];
  }

  return chars.join("");
}
